<!--<search></search> -->
<div class="row" style="margin:10px 0px;">
  <div class="col-md-12">
    <div class="panel panel-default" style="border: none;">
      <div class="panel panel-default" style="margin-top:10px;">
        <div class="panel-heading">
          <h4 class="panel-title">
            Step #1: Select monitoring locations to create advisories for.
          </h4>
        </div>
        <div class="panel-body">
          <div *ngIf="!loading" style="display: flex; justify-content: space-evenly;">
            <button class="btn btn-default" (click)="getBeaches('sampled', startDate, endDate)">
              Recently Sampled
            </button>
            <button class="btn btn-default" (click)="getBeaches('all',  startDate, endDate)">
              All
            </button>
            <button class="btn btn-default"
                    (click)="showDateSelect = true;">
              Activities Missing Advisories
            </button>
            <div style="padding-top:15px;" class="row" *ngIf="showDateSelect === true">
              <div class="col-xs-offset-3 col-xs-2">
                <div class="input-group">
                  <input type="text" class="form-control" ngbDatepicker
                         #p="ngbDatepicker" container="body"
                         [(ngModel)]="startDate" is-open="calendarOpen[startDate]"
                         placeholder="Start Date"
                  />
                  <span class="input-group-btn">
                                                    <button type="button" class="btn btn-default"
                                                            (click)="p.toggle()">
                                                <i class="fa fa-calendar"></i>
                                            </button>
                                        </span>
                </div>
              </div>
              <div class="col-xs-2">
                <div class="input-group">
                  <input type="text" class="form-control" ngbDatepicker
                         #d="ngbDatepicker" container="body"
                         [(ngModel)]="endDate" is-open="calendarOpen[endDate]"
                         placeholder="End Date"
                  />
                  <span class="input-group-btn">
                                                    <button type="button" class="btn btn-default"
                                                            (click)="d.toggle()">
                                                <i class="fa fa-calendar"></i>
                                            </button>
                                        </span>
                </div>
              </div>
              <div class="col-xs-1">
                <button class="btn btn-default"
                        [class]="selectedOption === 'missing' ? 'button-selected' : ''"
                        (click)="getBeaches('missing', startDate, endDate)">Go
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="loading" style="display: flex; justify-content: space-evenly;">
            <button class="btn btn-default"><i class="fa fa-pulse fa-spinner"></i></button>
          </div>

        </div>
      </div>
      <div class="panel panel-default" style="margin-top:10px;" *ngIf="items !== undefined">
        <div class="panel-heading">
          <h4 class="panel-title">
            Step #2: Select values to apply to all advisories in the list.
          </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <ng-template ngFor let-key [ngForOf]="meta.display_fields">
              <div *ngIf="key !== 'id' && meta.fields.hasOwnProperty(key)"
                   [class]="meta.fields[key].type == 'datetime' ? 'col-lg-6 col-md-8 col-sm-12' : 'col-lg-3 col-sm-6'">
                <app-dynamic-input [meta]="meta" [(item)]="item" [key]="key"
                                   (itemChange)="applyChange(key, item[key])">
                </app-dynamic-input>
<!--                <div [class]="{'has-error': meta.fields[key].hasError}">-->
<!--                  <label class="control-label">-->
<!--                    {{ meta.fields[key].label }}<span-->
<!--                    *ngIf="meta.fields[key].required"> *</span>-->
<!--                  </label>-->
<!--                </div>-->
<!--                <div [class]="{'has-error': meta.fields[key].hasError}">-->
<!--                  <input *ngIf="meta.fields[key].type == 'string'"-->
<!--                         type="text" (ngModelChange)="applyChange(key, item[key])"-->
<!--                         class="form-control" [(ngModel)]="item[key]"-->
<!--                         [required]="meta.fields[key].required"-->
<!--                         placeholder="{{ meta.fields[key].help_text }}"/>-->
<!--                  <input *ngIf="meta.fields[key].type == 'decimal' || meta.fields[key].type === 'float'"-->
<!--                         type="number" (ngModelChange)="applyChange(key, item[key])"-->
<!--                         step="0.1"-->
<!--                         class="form-control"-->
<!--                         [(ngModel)]="item[key]" string-to-number-->
<!--                         [required]="meta.fields[key].required"/>-->
<!--                  <input *ngIf="meta.fields[key].type == 'integer'" type="number" step="1"-->
<!--                         class="form-control" (ngModelChange)="applyChange(key, item[key])"-->
<!--                         [(ngModel)]="item[key]" [required]="meta.fields[key].required"/>-->
<!--                  <div *ngIf="meta.fields[key].type == 'datetime'">-->
<!--                    <div class="row">-->
<!--                      <div class="col-xs-7">-->
<!--                        <div class="input-group">-->
<!--                          <input type="text" class="form-control" ngbDatepicker-->
<!--                                 #d="ngbDatepicker" container="body"-->
<!--                                 [(ngModel)]="dates[key]" is-open="calendarOpen[key]"-->
<!--                                 [required]="meta.fields[key].required"-->
<!--                                 (ngModelChange)="applyChange(key, dates[key])"/>-->
<!--                          <span class="input-group-btn">-->
<!--                                                <button type="button" class="btn btn-default"-->
<!--                                                        (click)="d.toggle()">-->
<!--                                                    <i class="fa fa-calendar"></i>-->
<!--                                                </button>-->
<!--                                            </span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-xs-5" style="padding-left:0">-->
<!--                        <ngb-timepicker [(ngModel)]="times[key]" [meridian]="true"-->
<!--                                        (ngModelChange)="applyChange(key, dates[key])"-->
<!--                                        [spinners]="false">-->
<!--                        </ngb-timepicker>-->
<!--                        &lt;!&ndash;                                               <div type="text" class="form-control" uib-timepicker [(ngModel)]="item[key]"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                [required]="meta.fields[key].required"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                    (ngModelChange)="applyChange(key, item[key])">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                               </div>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                  <select *ngIf="meta.fields[key].type === 'choice' || (meta.fields[key].type === 'field'-->
<!--                                && !meta.fields[key].read_only)"-->
<!--                          class="form-control" (change)="applyChange(key, item[key])"-->
<!--                          [(ngModel)]="item[key]" [required]="meta.fields[key].required">-->
<!--                    <ng-template ngFor let-choice [ngForOf]="meta.fields[key].choices">-->
<!--                      <option [value]=choice.value>{{choice.display_name}}</option>-->
<!--                    </ng-template>-->

<!--                  </select>-->
<!--                  <label class="control-label" *ngIf="meta.fields[key].hasError">-->
<!--                    {{ meta.fields[key].errorMessage }}</label>-->
<!--                </div>-->
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="panel panel-default" style="margin-top:10px;" *ngIf="items !== undefined">
        <div class="panel-heading">
          <div class="panel-title">
            Step #3: Click on a advisory activity to change values for that specific activity.
            (Click the <i class="fa fa-times-circle"></i> to remove items from the list that you do
            not have an activity for.)
          </div>
        </div>
        <div class="panel-body">
          <div *ngIf="loading"><i class="fa fa-pulse fa-spinner"></i></div>
          <div *ngIf="!loading && items.length === 0">No recent samples needing advisories found.</div>
          <div *ngIf="!loading && items.length > 0" class="row table-responsive">
            <table class="table table-striped">
              <thead>
              <tr>
                <th>Beach</th>
                <th *ngIf="selectedOption === 'missing' || selectedOption === 'sampled'">Sample Date
                </th>
                <!-- <th *ngIf="item.sample_date">Sample Result</th>
                 <th *ngIf="item.sample_date">Sample Geomean</th> -->
                <ng-template ngFor let-key [ngForOf]="meta.display_fields">
                  <th *ngIf="meta.fields[key].type != 'field'
                              || (meta.fields[key].type === 'field' && meta.fields[key].read_only === true)">
                    {{ meta.fields[key].label }}
                  </th>
                </ng-template>
                <th>Remove</th>
              </tr>
              </thead>
              <!-- Moved ng-repeat from tbody to tr -->
              <tbody>
              <tr *ngFor="let item of items" style="border: none;">
                <td style="vertical-align: middle;">
                  {{ item.monitoring_location | display:meta.fields.monitoring_location.choices }}
                </td>
                <td *ngIf="item.sample_date" style="vertical-align: middle;">
                  {{ item.sample_date | date:'medium' }}
                </td>
                <!-- <td *ngIf="item.sample_date" style="vertical-align: middle;">
                        {{ item.measure }}
                    </td>
                    <td *ngIf="item.sample_date" style="vertical-align: middle;">
                        {{ item.geomean }}
                    </td> -->

                <ng-template ngFor let-key [ngForOf]="meta.display_fields">
                  <td style="vertical-align: middle; cursor: pointer;"
                      (click)="open(item, $event)">
                    <app-display-field [type]="meta.fields[key].type" [value]="item[key]"
                                       [choices]="meta.fields[key].choices"></app-display-field>
                  </td>
                </ng-template>
                <td style="vertical-align: middle; cursor: pointer;" (click)="delete(item)">
                  <i class="fa-regular fa-times-circle fa-lg" style="padding:0px 30%;"></i>
                </td>
              </tr>

              </tbody>
            </table>
            <p class="text-center">
              <button class="btn btn-primary" (click)="save()" *ngIf="!saving">Save</button>
              <button class="btn btn-primary" *ngIf="saving"><i class="fa fa-pulse fa-spinner"></i>
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

